/**
 * Recently Viewed Products — Sam's Store UAE
 * Saves + renders last 4 visited products using localStorage
 */

(function () {
    'use strict';

    var STORAGE_KEY = 'sams_recently_viewed';
    var MAX_ITEMS = 6;

    function getStored() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        } catch (e) {
            return [];
        }
    }

    function saveItem(item) {
        var list = getStored().filter(function (p) { return p.handle !== item.handle; });
        list.unshift(item);
        list = list.slice(0, MAX_ITEMS);
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        } catch (e) { /* storage full */ }
    }

    function money(cents) {
        return 'AED ' + (cents / 100).toFixed(0);
    }

    function buildCard(item) {
        return '<li class="recently-viewed__item">'
            + '<a href="' + item.url + '" class="recently-viewed__card">'
            + (item.image
                ? '<img src="' + item.image + '" alt="' + item.title + '" class="recently-viewed__card-img" loading="lazy" width="140" height="140">'
                : '')
            + '<div class="recently-viewed__card-info">'
            + '<span class="recently-viewed__card-name">' + item.title + '</span>'
            + '<span class="recently-viewed__card-price">' + money(item.price) + '</span>'
            + '</div>'
            + '</a>'
            + '</li>';
    }

    function renderStrip() {
        var strip = document.getElementById('recently-viewed');
        var list = document.getElementById('recently-viewed-list');
        if (!strip || !list) return;

        var currentHandle = strip.dataset.currentHandle || '';
        var items = getStored().filter(function (p) { return p.handle !== currentHandle; });

        if (items.length === 0) {
            strip.style.display = 'none';
            return;
        }

        list.innerHTML = items.slice(0, 4).map(buildCard).join('');
        strip.style.display = '';
    }

    function recordCurrentProduct() {
        var meta = document.getElementById('recently-viewed-meta');
        if (!meta) return; // not a product page

        var item = {
            handle: meta.dataset.handle,
            title: meta.dataset.title,
            url: meta.dataset.url,
            image: meta.dataset.image,
            price: parseInt(meta.dataset.price || '0', 10)
        };

        if (item.handle) {
            saveItem(item);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            recordCurrentProduct();
            renderStrip();
        });
    } else {
        recordCurrentProduct();
        renderStrip();
    }
})();
